import BaseModel from '../base/BaseModel.model';
import Tag from './tag.model';
import Record from './record.model';

export default class RecordTag extends BaseModel {

    public recordId?: number; 
    public tagId?: number; 
    public record?: Record | null; 
    public tag?: Tag | null; 
    public tagName?: string | null; 
    
    constructor() {
        super();
        this.init();
    }

    init() {
        this.recordId = 0;
        this.tagId = 0;
        this.record = null;
        this.tag = null;
        this.tagName = '';
    }
}